<template>
    <tailwind-layout title="Properties">
        <template #header>

            <div class="flex justify-between">
                <h2>Bank Accounts</h2>
            </div>

        </template>
        <div class="bg-rent-risk-blue-100 overflow-hidden shadow-xl sm:rounded-lg p-6">
            <div class="rounded-md shadow">
                <div class="flex flex-col">
                    <div class="">
                        <div class="align-middle inline-block min-w-full pb-8">
                            <div id="container"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import pickBy from 'lodash/pickBy'
import Button from "@/Jetstream/Button.vue";
import {loadConnectAndInitialize} from '@stripe/connect-js';
import axios from "axios";

export default {
    components: {
        Button,
        Icon,
        Pagination,
        TailwindLayout
    },
    props: {
        accounts: Object,
        publishable_key: String,
        client_secret: String,
        account_id: String,
    },
    data() {
    },
    mounted() {
        const fetchClientSecret = async () => {
            // Fetch the AccountSession client secret
            const response = await axios.post(this.route('connected-accounts.accountSession'), {
                account_id: this.account_id,
            })

            const {client_secret: clientSecret} = response.data;
            return clientSecret;
        }

        const stripeConnectInstance = loadConnectAndInitialize({
            // This is your test publishable API key.
            publishableKey: this.publishable_key,
            fetchClientSecret: fetchClientSecret,
            appearance: {
                // See all possible variables below
                overlays: "drawer",
            }
        });
        const container = document.getElementById("container");

        const accountOnboarding = stripeConnectInstance.create('account-onboarding');
        accountOnboarding.setCollectionOptions({
          fields: 'eventually_due',
          futureRequirements: 'include',
        })
        accountOnboarding.setOnExit(() => {
            // console.log('User exited the onboarding flow');
        });
        // console.log('accountOnboarding: '+JSON.stringify(accountOnboarding));
        container.appendChild(accountOnboarding);
    },
    methods: {

    }
}
</script>
